import { Box } from '@bfa/common-ui';
import React, { ReactNode } from 'react';

const testId = 'popup-body';

const Body = ({ children }: { children: ReactNode }) =>
  children ? (
    <Box
      marginTop="1.2rem"
      textAlign="center"
      marginBottom={['1.2rem', '3.2rem']}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: children as string,
      }}
      data-testid={testId}
    />
  ) : null;

export default Body;
